







































































import { Form } from 'element-ui';
import {
  Vue, Component, Prop, Emit, Watch,
} from 'vue-property-decorator';

@Component({
  name: 'InfoEditor',
})
export default class InfoEditor extends Vue {
  @Prop() private readonly initData!: any;

  @Prop({ default: 'Không thể thực hiện thao tác này khi đang chỉnh sửa' }) private readonly errorMessage!: string;

  @Prop({ default: 'Vui lòng chọn một giá trị' }) private readonly blankText!: string;

  @Prop({ default: 'Xác nhận sửa' }) private readonly confirmEdit!: string;

  @Prop({ default: 'Bỏ chọn' }) private readonly cancelSelect!: string;

  private isEditing = false;

  private privateData: any = {};

  private arrayData: any[] = [];

  @Watch('initData')
  onInitDataChange(value: any) {
    if (!this.isEditing) {
      if (!value) {
        this.privateData = {};
        this.arrayData = [];
        return;
      }
      this.privateData = value;
      const arrKey: string[] = Object.keys(value).filter((k: string) => (typeof value[k] === 'object' && value[k] !== null));
      if (arrKey.length) {
        arrKey.forEach((key: string) => {
          let privateData = JSON.parse(JSON.stringify(this.privateData));
          delete privateData[key];
          privateData = { ...privateData, ...value[key] };
          this.privateData = privateData;
        });
      }
      this.arrayData = value ? Object.entries(value) : [];
      this.arrayData.forEach(([key, val]: any[], index: number) => {
        if (arrKey.includes(key)) {
          const tmp = Object.entries(value[key]);
          const tmpArr = [...this.arrayData, ...tmp];
          tmpArr.splice(index, 1);
          this.arrayData = tmpArr;
        }
      });
    } else {
      this.$notify.error(
        this.errorMessage,
      );
    }
  }

  onSubmit() {
    (this.$refs.privateData as Form).validate((valid: boolean) => {
      if (valid) {
        this.isEditing = false;
        this.$emit('submit', this.privateData);
      }
    });
  }
}
